// src/routes/ProtectedRoute.tsx

import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: string | string[];
  requiredPermission?: string;
  fallback?: React.ReactNode;
  loadingFallback?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRole,
  requiredPermission,
  fallback = <h2>403 - Access Denied</h2>,
  loadingFallback = <div>Loading...</div>,
}) => {
  const { isAuthenticated, user, isLoading, hasPermission } = useAuth();

  if (isLoading) return <>{loadingFallback}</>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Role check (can allow multiple)
  if (requiredRole) {
    const allowedRoles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!user || !allowedRoles.includes(user.role)) {
      return <>{fallback}</>;
    }
  }

  // Permission check
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
